export const LOADING_MET = "LOADING_MET";
export const GET_MET_SUCCESS = "GET_MET_SUCCESS";
export const GET_MET_FAILURE = "GET_MET_FAILURE";

export const SET_MET_SEARCH_QUERY = "SET_MET_SEARCH_QUERY";
export const SET_MET_PAGE = "SET_MET_PAGE";

export const GET_MET_INFO_SUCCESS = "GET_MET_INFO_SUCCESS";
export const GET_MET_INFO_FAILURE = "GET_MET_INFO_FAILURE";
